<template>
    <v-menu
        v-model="showMenu"
        :disabled="readonly || disabled"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                :value="formattedValue"
                :label="label"
                :append-outer-icon="icons.calendar"
                autocomplete="off"
                readonly
                dense
                :clearable="!readonly && !disabled"
                :disabled="disabled"
                :rules="rules"
                @click:clear="onDateTextClear"
                @click:append-outer="showMenu = !showMenu"
                @click:append="showMenu = !showMenu"
                @click-prepend="showMenu = !showMenu"
                @click-prepend-outer="showMenu = !showMenu"
                v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker v-model="reactiveValue" no-title></v-date-picker>
    </v-menu>
</template>

<script>
export default {
    name: 'DateSelect',
    props: {
        // value format must be 'yyyy-mm-dd'
        value: {
            type: String,
            default: ''
        },
        displayFormat: {
            type: String,
            required: false,
            default: 'mm/dd/yyyy'
        },
        label: {
            type: String,
            default: ''
        },
        readonly: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        rules: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            showMenu: false
        };
    },
    computed: {
        reactiveValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.showMenu = false;
                this.$emit('input', newValue);
            }
        },
        formattedValue() {
            return this.formatDate(this.value);
        }
    },
    methods: {
        onDateTextClear() {
            this.reactiveValue = undefined;
        },
        formatDate(date, format) {
            if (!date) {
                return undefined;
            }
            if (format === 'mm/dd/yyyy') {
                const [year, month, day] = date.split('-');
                return `${month}/${day}/${year}`;
            }
            return date;
        },
        parseDate(date) {
            if (!date) {
                return null;
            }
            const [month, day, year] = date.split('/');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
    }
};
</script>

<style></style>
